import { getTheme } from './features/multi-tenancy/theme';

const theme = getTheme();

if (theme === 'rio') {
    // UIKIT reads <html data-brand="..."> during bootstrapping to choose its CSS theme.
    // Override index.html's Scania default explicitly; removing the attribute would use UIKIT's "default" theme.
    document.documentElement.dataset.brand = 'rio';

    // This is only the browser-tab title; it does not control the CSS theme.
    document.title = 'RIO SCM';
}

import('./appBootstrap').then(({ appBootstrap }) => appBootstrap());
